module.exports = __webpack_public_path__ + "static/image/history/pc/201506@3x.jpg?79360ac8";